import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const UserProfile = lazy(
  () =>
    import('./UserProfile.eager').then(mod => ({
      default: mod.UserProfile,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
